import React from "react";

import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

// ----------------------------------------------------------------------------

interface CardSkeletonProps {
    className?: string;
    count?: number;
}

export function CardSkeleton(props: CardSkeletonProps) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, count = 4 } = props;

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    const cardIndexes = Array.from({ length: count }, (_, index) => index);

    return (
        <div className={cn("w-full", className)}>
            {cardIndexes.map((index) => (
                <div
                    key={`card-skeleton-${index}`}
                    className="flex flex-col gap-3 p-3 border-b border-gray-100 last:border-0">
                    <div className="flex items-center gap-3 min-w-0">
                        <Skeleton className="h-10 w-10 rounded-md flex-shrink-0" />

                        <div className="flex items-center justify-between gap-3 min-w-0 flex-1">
                            <Skeleton className="h-5 w-28 max-w-full" />
                            <div className="flex flex-col items-end gap-1 shrink-0">
                                <Skeleton className="h-3 w-16" />
                                <Skeleton className="h-4 w-14" />
                            </div>
                        </div>
                    </div>

                    <div className="flex items-center gap-2 w-full sm:w-auto sm:ml-auto">
                        <Skeleton className="h-9 flex-1 rounded-md sm:w-36 sm:flex-none" />
                    </div>
                </div>
            ))}
        </div>
    );
}
